// import VideoModal from '../ModalVideo/VideoModal'
// import CountUp from 'react-countup'
// import abImg from '../../images/about/about-1/1.jpg'
import abImg2 from '../../images/cta/cat.jpg'

const CtaSection = (props) => {
  // const ClickHandler = () => {
  //   window.scrollTo(0, 0)
  // }

  return (
    <section id="cat" className={'' + props.hclass}>
      <div className="cat-wrap container">
        <div className="cat-content">
          <div className="content">
            <h2
              className="scroll-text-animation"
              data-animation="fade_from_right"
            >
              Our History Energized
            </h2>
            <span>CORE VALUES</span>
            <p className="fade_bottom">
              <b>Sagety:</b> Protecting the well-being of our employees, partners, and the communities in which we operate.
            </p>
            <p className="fade_bottom">
              <b>Integrity:</b> Conducting business with ethical standars and transparency across all operations.
            </p>
            <p className="fade_bottom">
              <b>Innovation:</b> Advancing through technology to improve effeciency and reducer environmental impact.
            </p>
            <p className="fade_bottom">
              <b>Responsibility:</b> Upholding sustainable practices to minimize our ecological.
              </p>
           
          </div>
        </div>
        <div>
          <div className="image">
            {/* <div className="image-1  poort-in-right">
              <img src={abImg2} alt="" />
            </div> */}
            <div className="image-2 poort-in-right">
              <img className="img-cat" src={abImg2} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CtaSection
